// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"31f1a400","993":"d65e2db1"}[chunkId] + ".chunk.js";
};